import clsx from 'clsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSparkles } from '@fortawesome/pro-regular-svg-icons'

type QuestionChipProps = {
  question: string
  onClick: () => void
  disabled?: boolean
  animationDelayMs?: number
  className?: string
}

export const QuestionChip = ({ question, onClick, disabled, animationDelayMs = 0, className }: QuestionChipProps) => (
  <button
    type="button"
    disabled={disabled}
    onClick={onClick}
    title={question}
    className={clsx(
      'tw-inline-flex tw-max-w-full tw-items-start tw-gap-2 tw-rounded-2xl tw-px-3.5 tw-py-2 tw-text-left tw-text-sm tw-opacity-0',
      'tw-bg-[var(--input-bg)] tw-border tw-border-[var(--border-default)] tw-text-[var(--text-primary)]',
      'tw-transition-all tw-duration-200',
      'hover:tw-border-brand hover:tw--translate-y-0.5',
      'disabled:tw-cursor-not-allowed disabled:hover:tw-translate-y-0',
      className,
    )}
    style={{ animation: 'fade-slide-in 0.4s ease-out forwards', animationDelay: `${animationDelayMs}ms` }}
  >
    <FontAwesomeIcon
      icon={faSparkles}
      className="tw-mt-0.5 tw-h-3.5 tw-w-3.5 tw-shrink-0"
      style={{ color: 'var(--brand-text)' }}
    />
    <span className="tw-break-words">{question}</span>
  </button>
)
